import { memo } from 'react';

import { Skeleton } from '@conversation-list/skeleton';
import { ConversationItem } from '../conversation-item';

import type { TRowConfig } from '../conversation-list.types';

import * as S from '../conversation-list.styles';

const ConversationRow = memo(({ index, style, data }: TRowConfig) => {
	const { conversations, hasMorePages } = data;

	if (hasMorePages && index === conversations.length) {
		return (
			<S.Loading style={style}>
				<Skeleton numOfElements={1} />
			</S.Loading>
		);
	}

	if (index < conversations.length) {
		const item = conversations[index];
		return (
			<div style={style}>
				<ConversationItem {...item} />
			</div>
		);
	}

	return null;
});

ConversationRow.displayName = 'ConversationRow';
export { ConversationRow };
